<nav class="topbar navbar navbar-light shadow-sm px-3">
    <div class="container-fluid position-relative d-flex align-items-center justify-content-between">
        
        <img src="assets/images/logo.png" width="100px" class="ms-5" />
        
        <div class="biorugged-title position-absolute top-50 start-50 translate-middle m-0 text-center">
            BioRugged SDK Manager
        </div>
        
        @if (showButtons) {
            <div class="d-flex gap-3">
                <i class="bi bi-person-circle text-white fs-4"></i>
                <i class="bi bi-box-arrow-right text-white fs-4 clickable" (click)="authService.signOut()"></i>
            </div>
        }
    </div>
</nav>